import React, { CSSProperties } from "react"
import FontIcon from "material-ui/FontIcon"
import ImageLoader from "../misc/ImageLoader"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import { IPunchDocument } from "../../models"
import { grey600, grey400 } from "material-ui/styles/colors"
interface IProps {
	punch: IPunchDocument
	toolTipKey?: string
	iconStyle?: CSSProperties
}
interface IState {
	open: boolean
}

export default class PunchImageToolTipColumn extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	render() {
		return (
			<div>
				<ToolTip
					active={this.state.open}
					position="right"
					arrow="center"
					parent={`#punch-image-${this.props.toolTipKey ? this.props.toolTipKey : ""}-${this.props.punch.Id}`}
					tooltipTimeout={50}
				>
					{this.props.punch.ImageID ?
						<div style={{ height: 250, minWidth: 150 }}>
							<ImageLoader url={this.props.punch.ImageS3Url} fixedHeight={250} src={"/punches/image/" + this.props.punch.ImageID} />
						</div> :
						this.props.punch.DeferredPhotoUpload ?
							<div style={{ height: 175, minWidth: 150 }}>
								<div style={{ width: 320, height: 75, textAlign: "center" }}>
									<h3>{strings.DefferedImageUploadTitle}</h3>
									<FontIcon className="fa fa-cloud-upload" style={{ fontSize: 90, color: "#aaaaaa" }} />
									<p>{strings.DefferedImageUploadBody}</p>
								</div>
							</div> :
							this.props.punch.DeviceId ?
								<div style={{ height: 75, minWidth: 150 }}>
									<div style={{ width: 320, height: 75, textAlign: "center" }}>
										<h3>{strings.No_image}</h3>
										<p>{strings.Punch_added_without_image}</p>
									</div>
								</div> :
								<div style={{ height: 75, minWidth: 150 }}>
									<div style={{ width: 320, height: 75, textAlign: "center" }}>
										<h3>{strings.No_image}</h3>
										<p>{strings.Punch_added_manually}</p>
									</div>
								</div>
					}
				</ToolTip>
				<FontIcon
					data-intercom-target={`ImageColumn-${this.props.punch && this.props.punch.Id}-Btn-OpenImageTooltip`}
					className={this.props.punch.DeferredPhotoUpload && !this.props.punch.ImageID ? "fa fa-cloud-upload" : "fa fa-picture-o"}
					style={{ color: this.props.punch.ImageID ? grey600 : grey400, ...this.props.iconStyle }}
					id={`punch-image-${this.props.toolTipKey ? this.props.toolTipKey : ""}-${this.props.punch.Id}`}
					onClick={() => this.setState({ open: !this.state.open })}
					onMouseOut={() => this.setState({ open: false })}
				/>
			</div>
		)
	}
}
